import React from 'react';
import { ReorderProduct } from '../customerDashboardTypes';
import styles from './AIReorderSuggestions.module.css';

interface AIReorderSuggestionsProps {
  products: ReorderProduct[];
  onAddToCart?: (skuId: number, quantity: number) => void;
}

const TrendIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
  </svg>
);

export const AIReorderSuggestions: React.FC<AIReorderSuggestionsProps> = ({ products, onAddToCart }) => {
  if (products.length === 0) return null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.icon}><TrendIcon /></span>
        <h3 className={styles.title}>AI Reorder Suggestions</h3>
      </div>
      <div className={styles.grid}>
        {products.map((product) => (
          <div key={product.id} className={styles.card}>
            <div className={styles.imagePlaceholder} />
            <div className={styles.info}>
              <p className={styles.name}>{product.name}</p>
              <p className={styles.qty}>Suggested qty: {product.suggestedQuantity}</p>
            </div>
            <button
              className={styles.addBtn}
              onClick={() => onAddToCart?.(product.skuId, product.suggestedQuantity)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
